import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { gameJoinAction } from '../../../../redux/actions/game.actions';
import PlayersbarSingle from './single/component';
Playersbar.propTypes = {
    players: PropTypes.array,
    showFacilitator: PropTypes.bool
};
export default function Playersbar(_a) {
    var _b = _a.players, propsPlayers = _b === void 0 ? null : _b, _c = _a.showFacilitator, showFacilitator = _c === void 0 ? false : _c;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var reduxPlayers = useSelector(function (state) { var _a, _b; return (_b = (_a = state.general) === null || _a === void 0 ? void 0 : _a.players) !== null && _b !== void 0 ? _b : []; });
    var players = propsPlayers || reduxPlayers;
    var rawUserSession = useSelector(function (state) { var _a; return (_a = state.userAuthorization) === null || _a === void 0 ? void 0 : _a.userSession; });
    var user = useMemo(function () {
        var _a, _b;
        return ({
            username: (_a = rawUserSession === null || rawUserSession === void 0 ? void 0 : rawUserSession.userName) !== null && _a !== void 0 ? _a : null,
            id: (_b = rawUserSession === null || rawUserSession === void 0 ? void 0 : rawUserSession.id) !== null && _b !== void 0 ? _b : null
        });
    }, [rawUserSession]);
    function onPlayerClick(token) {
        dispatch(gameJoinAction(token));
    }
    function onUserProfile() {
        navigate('/facilitator');
    }
    return (React.createElement("div", { className: "playerlisting" },
        players.map(function (player) { return (React.createElement(PlayersbarSingle, { player: player, onPlayerClick: function () { return onPlayerClick(player.token); }, key: player.id, visibleCode: true })); }),
        showFacilitator && user.username ? (React.createElement(PlayersbarSingle, { player: { avatar: '', name: user.username }, onPlayerClick: onUserProfile })) : null));
}
